export const GET_FUEL_RECORD = "GET_FUEL_RECORD";
export const UPDATE_FUEL_RECORD = "UPDATE_FUEL_RECORD";

export const SET_FUEL_RECORD_SELECTED_FRID = "SET_FUEL_RECORD_SELECTED_FRID";
export const CLEAR_FUEL_RECORD_SELECTED_FRID = "CLEAR_FUEL_RECORD_SELECTED_FRID";